// Layout Types
import { DefaultLayout } from "../layouts";

// Route Views
import Unauthorized from "../components/common/Unauthorized";
import LinkInvalid from "../components/common/LinkInvalid";

const UnauthorizedRoute = [
  {
    path: "/unauthorized",
    layout: DefaultLayout,
    component: Unauthorized,
  },
  {
    path: "/link-expired",
    layout: DefaultLayout,
    component: LinkInvalid,
  },
];
export default UnauthorizedRoute;
